import React, {useState} from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, FormGroup, Label, Input} from 'reactstrap';

const GradeLevelSelectorModal = ({isOpen, toggle, onConfirm}) => {
  const [selectedGradeLevel, setSelectedGradeLevel] = useState('');

  const gradeLevels = [
    'Early Childhood',
    'Pre-K-5',
    'Pre-K-8',
    'K-5',
    'K-8',
    '6-8',
    '6-12',
    '9-12',
    'K-12',
    'Alternative School',
    'Adult Education',
    'Education Administrator',
    'Supervisor'
  ];

  const handleConfirm = () => {
    if (selectedGradeLevel) {
      onConfirm(selectedGradeLevel);
      setSelectedGradeLevel('');
      toggle();
    }
  };

  const handleCancel = () => {
    setSelectedGradeLevel('');
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleCancel}>
      <ModalHeader toggle={handleCancel}>Grade Level Selection</ModalHeader>
      <ModalBody>
        <p>Please select the grade level you currently serve.</p>
        <FormGroup>
          <Label for="gradeLevelSelect">Grade Level</Label>
          <Input
            type="select"
            name="gradeLevel"
            id="gradeLevelSelect"
            value={selectedGradeLevel}
            onChange={(e) => setSelectedGradeLevel(e.target.value)}
          >
            <option value="">-- Select Grade Level --</option>
            {gradeLevels.map((level, index) => (
              <option key={index} value={level}>
                {level}
              </option>
            ))}
          </Input>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleConfirm} disabled={!selectedGradeLevel}>
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default GradeLevelSelectorModal;
